import React from 'react'
import { useSelector } from 'react-redux'

import { UserRole } from 'types/user'

import { selectCurrentUser } from 'store/users/users.selectors'

import Customer from './Customer'
import Manager from './Manager'

export interface OrderProps {
  onChange(value: string, id?: string): void
}

export const Order: React.FC<OrderProps> = ({ onChange }) => {
  const currentUser = useSelector(selectCurrentUser)
  switch (currentUser!.role) {
    case UserRole.CUSTOMER:
      return <Customer onChange={onChange} />
    default:
      return <Manager onChange={onChange} />
  }
}

export default Order
